import React from 'react';
import { useAdminData } from '../useAdminData';
import SocialLinksEditor from '../editors/SocialLinksEditor';

const SocialPage = () => {
    const { formData, isLoading, isSaving, success, handleFormChange, handleSave } = useAdminData();

    if (isLoading) return <div>Betöltés...</div>;
    if (!formData) return <div>Hiba az adatok betöltésekor.</div>;

    return (
        <div>
            <div className="admin-page-header">
                <h1>Közösségi Média</h1>
                <div>
                    {success && <span className="success-message">{success}</span>}
                    <button onClick={() => {handleSave(null); }} className="save-button" disabled={isSaving}>
                        {isSaving ? 'Mentés...' : 'Változtatások Mentése'}
                    </button>
                </div>
            </div>
            <SocialLinksEditor 
                links={formData.siteMeta.socialLinks}
                onFormChange={handleFormChange}
            />
        </div>
    );
};

export default SocialPage;